import newsAndAnalysis from './news'

export default {
  newsAndAnalysis,
}
